import { z } from "zod";
import { CatalogArticleItem } from "./storyblok";

// TODO: Copied (partially)from firebase/lmt/src/common/types. Replace the file there with imports from this file and move tests if any.

export const ArticleInquiry = z.object({
    article: CatalogArticleItem.partial({ fullSlug: true }),
    themeOrCategory: z.string().optional(),
});

export type ArticleInquiry = z.infer<typeof ArticleInquiry>;
